export const genders = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
  { label: 'Non-Binary', value: 'nonBinary' },
];

export const ethnicities = [
  { label: 'Hispanic / LatinX', value: 'hispanicOrLatinX' },
  { label: 'Not Hispanic / LatinX', value: 'notHispanicOrLatinX' },
];

export const races = [
  { label: 'American Indian / Alaska Native', value: 'americanIndianOrAlaskaNative' },
  { label: 'Asian', value: 'asian' },
  { label: 'Black', value: 'black' },
  {
    label: 'Native Hawaiian or Other Pacific Islander',
    value: 'hawaiianPacific',
  },
  { label: 'White', value: 'white' },
];
